var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content s-introduction"},[_c('h3',{staticClass:"title-p"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"des",domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.img),expression:"img"}],attrs:{"src":_vm.img,"alt":"加载失败"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }